var _path, _path2, _path3, _polyline, _line, _line2, _line3, _line4, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSystemAnalisaBanjir(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF0F3",
    d: "M44 87c24,0 43,-19 43,-43 0,-24 -19,-44 -43,-44 -24,0 -44,20 -44,44 0,24 20,43 44,43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 3.58433,
    strokeLinecap: "round",
    d: "M19 57c4,0 4,4 8,4 4,0 4,-4 9,-4 4,0 4,4 8,4 4,0 4,-4 8,-4 4,0 4,4 8,4 4,0 4,-4 8,-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 3.58433,
    strokeLinecap: "round",
    d: "M19 65c4,0 4,4 8,4 4,0 4,-4 9,-4 4,0 4,4 8,4 4,0 4,-4 8,-4 4,0 4,4 8,4 4,0 4,-4 8,-4"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 3.58433,
    points: "36,57 36,19 51,19 51,57"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 3.58433,
    x1: 51,
    y1: 29,
    x2: 44,
    y2: 29
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 3.58433,
    x1: 51,
    y1: 36,
    x2: 44,
    y2: 36
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 3.58433,
    x1: 51,
    y1: 43,
    x2: 44,
    y2: 43
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 3.58433,
    x1: 51,
    y1: 50,
    x2: 44,
    y2: 50
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#332C2B",
    fillRule: "nonzero",
    points: "26,51 26,38 30,38 24,29 18,38 22,38 22,51"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#332C2B",
    fillRule: "nonzero",
    points: "65,29 65,42 69,42 63,51 57,42 61,42 61,29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystemAnalisaBanjir);
export default __webpack_public_path__ + "static/media/icon_system_analisa_banjir.311d9ec24a40b9c28a4033926aa18b28.svg";
export { ForwardRef as ReactComponent };